/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Coins_TitleInputs */

const en_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insufficient Coins`)
};

const ar_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملات غير كافية`)
};

const de_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht genügend Münzen`)
};

const es_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monedas insuficientes`)
};

const fr_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces insuffisantes`)
};

const it_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monete Insufficienti`)
};

const ja_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コインが足りません`)
};

const ko_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 부족`)
};

const pt_br_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moedas insuficientes`)
};

const ru_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недостаточно монет`)
};

const th_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีเหรียญไม่เพียงพอ`)
};

const tr_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetersiz Jeton`)
};

const zh_cn_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金币不足`)
};

const zh_tw_dialog_not_enough_coins_title = /** @type {(inputs: Dialog_Not_Enough_Coins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金幣不足`)
};

/**
* | output |
* | --- |
* | "Insufficient Coins" |
*
* @param {Dialog_Not_Enough_Coins_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_coins_title = /** @type {((inputs?: Dialog_Not_Enough_Coins_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Coins_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_coins_title(inputs)
	if (locale === "ar") return ar_dialog_not_enough_coins_title(inputs)
	if (locale === "de") return de_dialog_not_enough_coins_title(inputs)
	if (locale === "es") return es_dialog_not_enough_coins_title(inputs)
	if (locale === "fr") return fr_dialog_not_enough_coins_title(inputs)
	if (locale === "it") return it_dialog_not_enough_coins_title(inputs)
	if (locale === "ja") return ja_dialog_not_enough_coins_title(inputs)
	if (locale === "ko") return ko_dialog_not_enough_coins_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_coins_title(inputs)
	if (locale === "ru") return ru_dialog_not_enough_coins_title(inputs)
	if (locale === "th") return th_dialog_not_enough_coins_title(inputs)
	if (locale === "tr") return tr_dialog_not_enough_coins_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_coins_title(inputs)
	return zh_tw_dialog_not_enough_coins_title(inputs)
});